import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorDescription: {
		id: 'linked-alerts.common.error-description',
		defaultMessage: "We're not quite sure what went wrong. Refresh the page if the error persists.",
		description: 'Generic error message shown to users.',
	},
});
